import Query from '../../components/Report';

export default new Query('data-back-fill');
